import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function Trust({ content }) {
  return (
    <section className="section bg-[#1E3F33] text-white relative overflow-hidden">
      <div className="absolute -top-32 -left-20 w-96 h-96 rounded-full bg-[#C86646]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-20 w-96 h-96 rounded-full bg-[#2D6A4F]/30 blur-3xl pointer-events-none" />

      <div className="container-z relative grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="rounded-3xl overflow-hidden border border-white/10">
            <div
              className="aspect-[4/5] bg-cover bg-center"
              style={{ backgroundImage: `url(${content.trust_image_url})` }}
            />
          </div>
          <div className="absolute -bottom-6 -right-4 sm:right-8 bg-white text-[#1A231E] rounded-2xl p-4 shadow-xl max-w-[230px]">
            <div className="text-xs font-bold uppercase tracking-wider text-[#C86646] mb-1">
              Real broker, Pune
            </div>
            <div className="text-sm font-semibold leading-snug">
              "Closed 4 deals last month — every contact was an actual owner."
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="label-mono mb-3 !text-[#E9C46A]">For brokers, by brokers</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {content.trust_text}
          </h2>
          <p className="mt-5 text-base text-white/75 leading-relaxed">
            We grew up in Indian property markets — chasing leads on roadside boards, dealing
            with fake numbers, and losing deals to outdated portals. Zumroo is the tool we wished
            existed.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4 sm:gap-6">
            {[
              { k: "1.2K+", v: "Active brokers" },
              { k: "8K+", v: "Owner listings" },
              { k: "₹0", v: "Subscription fee" },
            ].map((s) => (
              <div key={s.v} className="border-l-2 border-[#C86646]/70 pl-4">
                <div className="font-display text-2xl sm:text-3xl font-bold text-white">{s.k}</div>
                <div className="text-xs sm:text-sm text-white/60 mt-0.5">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-start gap-3 text-white/80 text-sm">
            <Quote className="w-5 h-5 text-[#C86646] flex-shrink-0 mt-0.5" />
            <p className="italic leading-relaxed">
              "Finally, a platform that respects how brokers actually work. No fluff, just owner
              numbers when I need them."
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
